import * as React from "react"
import { List, Datagrid, TextField, EditButton, CreateButton } from "react-admin"

export const NewsList = (props) => (
	<List {...props} pagination={false} actions={<CreateButton label="Ajouter" />}>
		<Datagrid>
			<TextField source="title" label="Titre de l'article" />
			<EditButton label="Editer" />
		</Datagrid>
	</List>
)
